import { ReactComponent as InfoIconXYZ } from "../icons/Info24.svg";

import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
function InfoIcon({ text }) {
  return (
    <>
      <Tooltip
        title={<Typography color="inherit">{text}</Typography>}
        placement="right"
      >
        <InfoIconXYZ
          sx={{
            verticalAlign: "middle",
            display: "inline-flex",
            cursor: "pointer",
          }}
          color="primary"
        />
      </Tooltip>
    </>
  );
}
export default InfoIcon;
